// Generated by BUCKLESCRIPT VERSION 4.0.18, PLEASE EDIT WITH CARE
'use strict';


function courses(domain, campus_id, categories_id, formation_type) {
  return "" + (String(domain) + ("/wp-json/custom_api/v1/grouped_courses?campus_id=" + (String(campus_id) + ("&categories_id=" + (String(categories_id) + ("&formation_type=" + (String(formation_type) + "")))))));
}

function free_courses(domain, tipo_id, categoria_id) {
  return "" + (String(domain) + ("/wp-json/custom_api/v1/cursos_livres?tipo_id=" + (String(tipo_id) + ("&categoria_id=" + (String(categoria_id) + "")))));
}

function faq(domain, category_id) {
  return "" + (String(domain) + ("/wp-json/custom_api/v1/faq?categoriesId=" + (String(category_id) + "")));
}

function news(domain) {
  return "" + (String(domain) + "/wp-json/custom_api/v1/news");
}

var API = /* module */[
  /* courses */courses,
  /* free_courses */free_courses,
  /* faq */faq,
  /* news */news,
  /* spots */"https://sps.unasp.br/api/process_steps_with_spots"
];

exports.API = API;
/* No side effect */
